
import { asyncLoader } from "@/router/route-helper"
// () => asyncLoader(() => import('@/views/redeem/redeem.vue')) // peError: a.then is not a function
export default  [

    {
        path: '/profile',
        name: 'profile',
        component: () => import('@/views/users/employee-profile.vue'),
        meta: { requiresAuth: true, role: 'super_admin' },
    },
    {
        path: '/events',
        name: 'events',
        component: () => import('@/views/apps/calendar.vue'),
        meta: { requiresAuth: true, role: 'super_admin' },
    },

    {
        path: '/catalog',
        name: 'catalog',
        component: () => import('@/views/catalog/catalog.vue'),
        meta: { requiresAuth: true, role: 'super_admin' },
        children: [
            {
                path: '',
                redirect: '/catalog/category',
                meta: { requiresAuth: true, role: 'super_admin' },
              },
            { 
                 path: 'category',
                component: () => import('@/views/catalog/category/category.vue'),
                name: "category",
                meta: { requiresAuth: true, role: 'super_admin' },
            },
            {
                path: 'sub-category', 
                component: () => import('@/views/catalog/sub-category/sub-category.vue'),
                name: "sub-category",
                meta: { requiresAuth: true, role: 'super_admin' },
            },
            { 
                path: 'shift', 
                component: () => import('@/views/catalog/shift/shift.vue'),
                meta: { requiresAuth: true, role: 'super_admin' },
            },
          ]
    },
    {
        path: '/users',
        name: 'employees',
        component: () => import('@/views/users/employee.vue'),
        meta: { requiresAuth: true, role: 'super_admin' },
    },
    {
        path: '/employee/add',
        name: 'add-employee',
        component: () => import('@/views/users/add-or-update-employee.vue'),
        meta: { requiresAuth: true, role: 'super_admin' },
    },
    {
        path: '/employee/update/:employee_id',
        name: 'update-employee',
        component: () => import('@/views/users/add-or-update-employee.vue'),
        meta: { requiresAuth: true, role: 'super_admin' },
    },
    {
        path: '/points/list',
        name: 'points',
        component: () => import('@/views/points/points.vue'),
        meta: { requiresAuth: true, role: 'super_admin' },
    },

    {
        path: '/points/add',
        name: 'add-points',
        component: () => import('@/views/points/add-or-update-points.vue'),
        meta: { requiresAuth: true, role: 'super_admin' },
    },
    {
        path: '/points/update/:point_id',
        name: 'update-points',
        component: () => import('@/views/points/add-or-update-points.vue'),
        meta: { requiresAuth: true, role: 'super_admin' },
    },
    {
        path: '/points/received-redeem-requests',
        name: 'received-redeem-requests',
        component: () => import('@/views/redeem/admin/redeem.vue'),
        meta: { requiresAuth: true, role: 'super_admin' },
    },
    {
        path: '/points/update/received-redeem-requests/:redeem_id',
        name: 'update-received-redeem-requests',
        component: () => import('@/views/redeem/admin/add-or-update-redeem.vue'),
        meta: { requiresAuth: true, role: 'super_admin' },
    },
    {
        path: '/teams',
        name: 'teams',
        component: () => import('@/views/team/team.vue'),
        meta: { requiresAuth: true, role: 'super_admin' },
    },
    {
        path: '/teams/job-titles',
        name: 'job-titles',
        component: () => import('@/views/team/job-title/job-title.vue'),
        meta: { requiresAuth: true, role: 'super_admin' },
    },
    {
        path: '/teams/job-prefixes',
        name: 'job-prefixes',
        component: () => import('@/views/team/job-prefix/job-prefix.vue'),
        meta: { requiresAuth: true, role: 'super_admin' },
    },
    {
        path: '/index2',
        name: 'index2',
        component: () => import('@/views/index2.vue'),
        meta: { requiresAuth: true, role: 'super_admin' },
    },
    {
        path: '/index2',
        name: 'index2',
        component: () => import('@/views/index2.vue'),
        meta: { requiresAuth: true, role: 'super_admin' },
    },
];
